import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBContainer,
  MDBRow,
  MDBValidation,
  MDBValidationItem,
  MDBCardTitle,
  MDBCardText,
  MDBCheckbox


}
from 'mdb-react-ui-kit';
import '../../../css/index.css';



function EditarAluno() {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState([]);
  const util = require('../../../utils/index');
  const userLogin = util.getUser();
  const api = require('../../../apis/aluno')
  const {id} = useParams();

  const [formValue, setFormValue] = useState({
    nomeAluno: '', 
    ra: '', 
    codTurma: ''
  });

  const [checked, setChecked] = useState(false);

  const handleSubmit = async (values) => {
    values.preventDefault();
    util.isSubmitting()
    const result = await api.atualizarAlunoApi(formValue);
    result ? toast.success("Atualizado com sucesso!") && navigate("/area-aluno") : null;
    util.isSubmitting()
    
  }

  const handleDelet = async () => {
    const object = {
        id: id
    }
    util.isSubmitting()
    const result = await api.excluirAlunoApi(object);
    result ? toast.success("Excluido com sucesso!") && navigate("/area-aluno") : null;
    util.isSubmitting()
    
  }

  useEffect(() => {
    const getAluno = async () => {
      try {
        const object = {
          id: id,
        };
        const response = await api.pegarAlunoApi(object);
        const data = await response;
        
        setUsuario(data[0]);
        
        setFormValue({
          nomeAluno: data[0].nomealuno, 
          ra: data[0].ra, 
          codTurma: data[0].codturma
        });
      } catch (error) {
        console.error('Erro ao obter dados:', error);
      }
    };

    getAluno();
  }, [id]);

  const onChange = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  const onBlur = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  return (
    <MDBContainer fluid className=' background-radial-gradient' style={{
      minHeight:'500px',display:"flex", justifyContent:"center", alignItems:"center"
      
      }}>
      <MDBRow center className='w-100 d-flex my-5 flex-column align-items-center'>

          <MDBCard className='bg-dark text-white w-50' style={{borderRadius: '1rem', minWidth: '300px'}}>
              <MDBCardBody className='d-flex flex-column align-items-center'>

              <MDBCardTitle className='text-white my-4'>Bem vindo, {util.decideName(userLogin)}</MDBCardTitle>
                  <MDBValidation className='w-100' onSubmit={!checked ? handleSubmit : handleDelet}>
                    <MDBValidationItem feedback='Por favor digite nome do aluno!' invalid>
                      <MDBInput 
                        wrapperClass='mb-3 w-100' 
                        labelClass='text-white' 
                        label='Nome' 
                        name='nomeAluno'
                        id='formControNomeAluno' 
                        type='text' 
                        size="lg"
                        value={formValue.nomeAluno || ''}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        style={{color:"white"}}/>
                    </MDBValidationItem >
                    <MDBValidationItem feedback='Por favor digite o ra do aluno!' invalid>
                      <MDBInput 
                        wrapperClass='mb-3 w-100' 
                        labelClass='text-white' 
                        label='RA' 
                        name='ra'
                        id='formControRA' 
                        type='text' 
                        size="lg"
                        value={formValue.ra || ''}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        style={{color:"white"}}/>
                    </MDBValidationItem >
                    <MDBValidationItem feedback='Por favor digite o código da turma!' invalid>
                      <MDBInput 
                        wrapperClass='mb-3 w-100' 
                        labelClass='text-white' 
                        label='CodTurma' 
                        name='codTurma'
                        id='formControCodTurma' 
                        type='text' 
                        size="lg"
                        value={formValue.codTurma || ''}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        style={{color:"white"}}/>
                    </MDBValidationItem >
                    
                    
                    <div className='my-2'>
                        <MDBCheckbox

                            id='controlledCheckbox'
                            label='Habilitar botão "Exluir"'
                            checked={checked}
                            onChange={() => setChecked(!checked)}
                        />
                    </div>
                    <div className='d-flex justify-content-between align-items-center flex-column'>
                        <MDBBtn 
                            outline 
                            className='my-3 btn-home w-100' 
                            color='white' 
                            size='lg'
                            type='submit'   
                            id='submitForm'  
                            disabled={!checked}                 
                            >
                            
                            excluir
                        </MDBBtn>
                        <MDBBtn 
                            outline 
                            className='px-5 w-100 btn-home' 
                            color='white' 
                            size='lg'
                            type='submit'   
                            id='submitForm'  
                            disabled={false}                 
                            >
                            
                            Editar
                        </MDBBtn>
                      </div>
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 mt-4 btn-home' 
                        color='white' 
                        size='sm'
                        type='submit'   
                        onClick={() => {
                          navigate("/listar-aluno")
                        }}
                        >
                        
                        Voltar
                      </MDBBtn>
                  </MDBValidation>
              </MDBCardBody>
          </MDBCard>
      </MDBRow>

    </MDBContainer>
  );
}

export default EditarAluno;
